import * as Locale from '../../state/locale/Locale.selectors';

import Component from './LocalizedTooltip.component';
import { connect } from 'react-redux';

export const mapStateToProps = state => ({
    shouldRetranslate: Locale.shouldRetranslate(state),
});

/** @type {React.FC<import('@mui/material').TooltipProps & Omit<import('./LocalizedTooltip.component').LocalizedTooltipProps,keyof ReturnType<mapStateToProps>>} */
export default connect(mapStateToProps, {})(Component);
